import { FetchData } from '../../cloneme-classes';
import { getCurrentDomainFolder } from '../../utils';

declare const USE_SIMPLE_LOGIN:string;

export class LoginRedirect {
  public async init(): Promise<void> {
    await this.setup();
  }

  public async setup(): Promise<void> {
    const loginRedirectUrl = localStorage.getItem('redirect-url');
    FetchData.loginRedirect(location.search + `&source=${loginRedirectUrl || ''}`)
      .then((res: any) => {
        localStorage.setItem('jwt', res.jwt);
        localStorage.setItem('username', res.user.username);
        localStorage.setItem('email', res.user.email);
        localStorage.setItem(
          'auth0_jwt',
          new URLSearchParams(window.location.search || '').get('id_token') || ''
        );

        let targetPage;

        if(USE_SIMPLE_LOGIN == "1") {
            const loginRedirect = localStorage.getItem('redirect-url');
            targetPage = loginRedirect ? decodeURIComponent(loginRedirect) : getCurrentDomainFolder();
            localStorage.removeItem('redirect-url');
        } else {
            if (!res.user.confirmed) {
                targetPage = `${getCurrentDomainFolder()}/auth/email-verification`;
            } else if (USE_SIMPLE_LOGIN && !res.user.hasCompletedInitialSetup) {
                targetPage = `${getCurrentDomainFolder()}/auth/register-redirect`;
            } else {
                const loginRedirect = localStorage.getItem('redirect-url');
                targetPage = loginRedirect ? decodeURIComponent(loginRedirect) : getCurrentDomainFolder();
                localStorage.removeItem('redirect-url');
            }
        }

        window.location.href = targetPage;
      })
      .catch((err: any) => {
        console.error(err);
      });
  }
}
